import { useState, useEffect } from 'react'
import { PortalId } from '../layouts/types'

export const useDockedFooterElement = (): { footerElement: HTMLElement | null; isClient: boolean } => {
  const [footerElement, setFooterElement] = useState<HTMLElement | null>(null)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
    try {
      const element = document.getElementById(PortalId.DockedFooter)
      setFooterElement(element)
    } catch (error) {
      // Handle getElementById errors gracefully
      setFooterElement(null)
    }
  }, [])

  return { footerElement, isClient }
}
